const React = require('react');
const map = require('mn-utils/map');
const formatTime = require('mn-utils/formatTime');
const upperFirst = require("mn-utils/upperFirst");

const DataBlock = require('./DataBlock');

module.exports = (props) => {
  const data = props.data || {};

  const dataArr = [
    {
      title: 'Invoice number',
      value: data.number,
    },
    {
      title: 'Invoice Amount',
      value: <span className="c2CE889 tdU">{data.amount}</span>,
    },
    {
      title: 'Currency',
      value: data.currency_code,
    },
    {
      title: 'Invoice date and time',
      value: formatTime(data.created_at, '{dddd} {mmmm} {dd}, {yyyy}'),
    },
    {
      title: 'Invoice due',
      value: '7 days from the date of Invoice',
    },
    {
      title: 'Status',
      value: (
        <span
          className={`cFFBF43.pending c2CE889.paid ${data.state}`}
        >
          {!!data.state && upperFirst(data.state)}
        </span>
      ),
    },
  ];

  return (
    <div className="wmax670 layoutRow fxwWrap mh-15 mb34">
      {map(dataArr, (item, i) => (
        <div key={i} className="w1/3 w1/2@m w@m2 mt21 ph15">
          <DataBlock title={item.title} value={item.value} />
        </div>
      ))}
    </div>
  );
};
